import { Button, Paper } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import VideoFrom from "../../components/form/VideoFrom";
import { useAddSeries, useUpdateSeries } from "../../utils/mutations";
import { useSeriesById } from "../../utils/queries";
import useStore from "../../utils/store";

const AddSeries = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const id = params.id;
  const page = searchParams.get("page") || "1";
  

  useEffect(() => {
    if (id && !user?.updateSeries) {
      notifications.show({ message: "You don't have permission to edit series", color: "red" });
      navigate(`/series?page=${page}`);
    } else if (!id && !user?.addSeries) {
      notifications.show({ message: "You don't have permission to add series", color: "red" });
      navigate(`/series?page=${page}`);
    }
  }, [id, user, navigate, page]);

  const { isPending, mutate } = useAddSeries();
  const { isPending: isUpdating, mutate: update } = useUpdateSeries({
    onSuccess: () => {
      navigate(`/series?page=${page}`);
    },
  });
  const { data, isLoading } = useSeriesById(params.id);
  

  if (!user?.addSeries && !user?.updateSeries) {
    return null;
  }

  return (
    <>
      
      <Paper withBorder p="md"
        loading={isLoading}
        title={id ? "Edit Series" : "Add Series"}
        style={{
          maxWidth: "600px",
          width: "100%",
          marginInline: "auto",
        }}
      >
        <VideoFrom
          type="Series"
          onFinish={(formData) => {
            if (id) {
              update({ id: id, data: formData });
            } else {
              mutate(formData);
            }
          }}
          update={data}
          submit={
            <Button
              type="submit"
              loading={isPending || isUpdating}
            >
              {id ? "Update" : "Add"}
            </Button>
          }
        />
      </Paper>
    </>
  );
};

export default AddSeries;
